/* eslint-disable no-mixed-operators */
import {
  FontWeights,
  getTheme,
  IButtonStyles,
  IconButton,
  IIconProps,
  mergeStyleSets,
  MessageBar,
  MessageBarType,
  Modal,
} from "@fluentui/react";
import React from "react";
import Accordion from "../Accordion/Accordion";
import { IEvidenceDetail, IEvidenceResponse } from "../../services";

interface IExpertEvidenceModalProps {
  isModalOpen: boolean;
  hideModal: any;
  titleId: string;
  currentDetailsModal: IEvidenceResponse | null;
}

export default class ExpertEvidenceModal extends React.Component<
  IExpertEvidenceModalProps,
  any
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: false,
      items: [],
    };
  }

  componentDidMount(): void {
    this.setState({
      isLoading: true,
    });
  }

  theme = getTheme();

  contentStyles = mergeStyleSets({
    container: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
    },
    header: [
      this.theme.fonts.xLargePlus,
      {
        flex: "1 1 auto",
        borderTop: `4px solid ${this.theme.palette.themePrimary}`,
        borderBottom: "1px solid rgba(0,0,0,.125)",
        color: this.theme.palette.neutralPrimary,
        display: "flex",
        alignItems: "center",
        fontWeight: FontWeights.semibold,
        padding: "24px 24px",
      },
    ],
    heading: {
      color: this.theme.palette.neutralPrimary,
      fontWeight: FontWeights.semibold,
      fontSize: "inherit",
      margin: "0",
    },
    body: {
      flex: "4 4 auto",
      padding: "24px 24px",
      overflowY: "hidden",
      selectors: {
        p: { margin: "14px 0" },
        "p:first-child": { marginTop: 0 },
        "p:last-child": { marginBottom: 0 },
      },
    },
  });

  iconButtonStyles: Partial<IButtonStyles> = {
    root: {
      color: this.theme.palette.neutralPrimary,
      marginLeft: "auto",
      marginTop: "4px",
      marginRight: "2px",
    },
    rootHovered: {
      color: this.theme.palette.neutralDark,
    },
  };

  cancelIcon: IIconProps = { iconName: "Cancel" };

  BlockedExample = () => (
    <MessageBar
      messageBarType={MessageBarType.error}
      style={{ fontSize: "1rem", fontFamily: "BoschFont" }}
    >
      504 - Internal server error
    </MessageBar>
  );

  render() {
    const { currentDetailsModal } = this.props;
    return (
      <Modal
        isOpen={this.props.isModalOpen}
        onDismiss={this.props.hideModal}
        isBlocking={false}
        containerClassName={this.contentStyles.container}
      >
        <div className={this.contentStyles.header}>
          <h2 className={this.contentStyles.heading} id={this.props.titleId}>
            Evidence Details
          </h2>
          <IconButton
            styles={this.iconButtonStyles}
            iconProps={this.cancelIcon}
            ariaLabel="Close popup modal"
            onClick={this.props.hideModal}
          />
        </div>
        <div className={this.contentStyles.body}>
          {!!currentDetailsModal &&
            !!currentDetailsModal.evidences &&
            currentDetailsModal.evidences.length > 0 &&
            currentDetailsModal.evidences.map((item: IEvidenceDetail, index: number) => {
              return (
                <Accordion
                  key={index}
                  title={item.contentprovider.label}
                  count={item.totalDocuments}
                  details={item.documents}
                />
              );
            }) || this.BlockedExample()}
        </div>
      </Modal>
    );
  }
}
